import RoomAdvisorSettings from '@/components/Room/RoomAdvisorSettings'

const RoomAdvisorSettingsScreen = () => {
  return <RoomAdvisorSettings />
}

export default RoomAdvisorSettingsScreen

